// extracted by mini-css-extract-plugin
module.exports = {"content":"style-module--content--3U38B","section":"style-module--section--1KyNs"};